module.exports = __webpack_public_path__ + "img/sub_ord-sucs.8524caec.png";